import { patronatInfoService } from "../../services/api";

interface PatronatInfo {
  name: string;
  text: string;
}


let patronatInfoList: PatronatInfo[] = [
  {
    name: "missionTop",
    text: "Допомога пораненим Бійцям: супровід під час лікування та реабілітації, сприяння у вирішенні гуманітарних, юридичних та медичних питань. Організація протезування для Бійців з ампутаціями, забезпечення фізичної та психологічної реабілітації",
  },
  {
    name: "missionBottom",
    text: "Підтримка родин загиблих, зниклих безвісти та полонених військовослужбовців: надання необхідної інформації, юридичний супровід, допомога у вирішенні соціальних питань",
  },
  {
    name: "phone1",
    text: "067 672 82 58",
  },
  {
    name: "phone2",
    text: "067 673 15 85",
  },
  {
    name: "email",
    text: "210polk.army@gmail.com",
  },
  {
    name: "supportLink",
    text: "https://send.monobank.ua/jar/A7ceAqmmMT",
  },
  {
    name: "feedbackLink",
    text: "https://docs.google.com/forms/d/e/1FAIpQLSfPSOdw-BQ5cgX23s8uDB_uGVHbsxG735MJ2vcdbsHHaozl-g/viewform?usp=header",
  },
];

export async function loadPatronatInfo() {
  try {
    // Call the API to get all patronat info entries
    const response = await patronatInfoService.getAll();

    // Extract the data from the response
    const newPatronatInfoList: PatronatInfo[] = response.data;

    // Sort by name before storing
    patronatInfoList = newPatronatInfoList.sort((a, b) => a.name.localeCompare(b.name));
    
    return patronatInfoList;
  } catch (error) {
    console.error("Failed to load patronat info:", error);
    throw new Error("Не вдалося завантажити інформацію патронату");
  }
}

// Create function
export async function createPatronatInfo(data: { name: string; text: string }) {
  try {
    const response = await patronatInfoService.create(data);
    
    // Reload the list to get the updated data
    await loadPatronatInfo();
    
    return response.data;
  } catch (error) {
    console.error("Failed to create patronat info:", error);
    if (error.response?.status === 409) {
      throw new Error("Запис з такою назвою вже існує");
    }
    throw new Error("Не вдалося створити запис");
  }
}

// Update function
export async function updatePatronatInfo(name: string, data: { text: string }) {
  try {
    const response = await patronatInfoService.update(name, data);
    
    // Reload the list to get the updated data
    await loadPatronatInfo();
    
    return response.data;
  } catch (error) {
    console.error("Failed to update patronat info:", error);
    if (error.response?.status === 404) {
      throw new Error("Запис не знайдено");
    }
    throw new Error("Не вдалося оновити запис");
  }
}

// Delete function
export async function deletePatronatInfo(name: string) {
  try {
    const response = await patronatInfoService.delete(name);
    
    // Reload the list to get the updated data
    await loadPatronatInfo();
    
    return response.data;
  } catch (error) {
    console.error("Failed to delete patronat info:", error);
    if (error.response?.status === 404) {
      throw new Error("Запис не знайдено");
    }
    throw new Error("Не вдалося видалити запис");
  }
}


export function getPatronatInfoByName(name: string) {
    return (patronatInfoList.find(item=>item.name == name)??{text:""}).text ?? "";
}
